module.exports = __webpack_public_path__ + "img/telegram.486b50c3.svg";